enum DirectDebitAgreementStatus {
  NONE = 'NONE',
  SUSPENDED = 'SUSPENDED',
}

export default DirectDebitAgreementStatus;
